<div 
  class="custom-menu" 
  *ngIf="visible"
  [style.left.px]="left" 
  [style.top.px]="top"
  (click)="$event.stopPropagation()"
>
  <div
    class="menu-item" 
    *ngFor="let item of menuItems"
    (click)="selectItem(item)"
  >
    {{ item.label }}
  </div>
</div>
